export const seoKeys = {
  keywords: (locationId: string, page?: number) =>
    page !== undefined
      ? (['seo', 'keywords', locationId, page] as const)
      : (['seo', 'keywords', locationId] as const),
  metrics: (locationId: string) => ['seo', 'metrics', locationId] as const,
  overview: (locationId: string) => ['seo', 'overview', locationId] as const,
  visibilityOverview: (locationId: string) => ['seo', 'visibility-overview', locationId] as const,
  auditLatest: (locationId: string) => ['seo', 'audit', 'latest', locationId] as const,
  auditStatus: (locationId: string) => ['seo', 'audit', 'status', locationId] as const,
  siteHealth: (locationId: string) => ['seo', 'site-health', locationId] as const,
  content: (locationId: string) => ['seo', 'content', locationId] as const,
  contentItems: (locationId: string) => ['seo', 'content-items', locationId] as const,
  contentPreference: (locationId: string) => ['seo', 'content-preference', locationId] as const,
  dailyClicks: (locationId: string) => ['seo', 'daily-clicks', locationId] as const,
  searchTerms: (locationId: string) => ['seo', 'search-terms', locationId] as const,
  searchTermSuggestions: (locationId: string) =>
    ['seo', 'search-terms', locationId, 'suggestions'] as const,
  rankTable: (locationId: string) => ['seo', 'rank-table', locationId] as const,

  // AI Visibility
  aiVisibilityScore: (locationId: string) => ['seo', 'ai-visibility', 'score', locationId] as const,
  aiVisibilityQuestions: (locationId: string) =>
    ['seo', 'ai-visibility', 'questions', locationId] as const,
  aiVisibilityCompetitorShare: (locationId: string) =>
    ['seo', 'ai-visibility', 'competitor-share', locationId] as const,
};
